<template>
	<div>
		<Header />
		<div class="content-admin-ads">
			<b-container fluid="md">
				<b-row>
					<b-col class="content-left">
						<DashboardNavigateAds :activeNavigation="displayedComponent" />
					</b-col>
					<b-col class="content-right">
						<div class="wrap-content">
							<Greeting />
							<div class="content-body">
								<component :is="displayedComponent" />
							</div>
						</div>
					</b-col>
				</b-row>
			</b-container>
		</div>
	</div>
</template>

<script>
import DashboardNavigateAds from '@/components/admin/adsDashboard/adsDashboardNavigate/AdsDashboardNavigate';
import Header from '@/components/ui/header/index.vue';
import Greeting from '@/components/admin/ui/greeting/Greeting';

import AdsAddCustomer from '@/components/admin/adsDashboard/adsAddCustomer/AdsAddCustomer';
import Profile from '@/components/admin/common/profile/Profile';
import AdsCreateAds from '@/components/admin/adsDashboard/adsCreateAds/AdsCreateAds';

export default {
	components: {
		DashboardNavigateAds,
		Greeting,
		Header,
		AdsAddCustomer,
		Profile,
		AdsCreateAds
	},
	data() {
		return {
			displayedComponent: 'AdsAddCustomer'
		};
	},
	metaInfo() {
		return {
		title: `${this.$root.siteTitle}`,
		}
	},
	watch: {
		$route(newVal) {
			this.displayedComponent = newVal.name;
		}
	},
	created() {
		this.displayedComponent = this.$route.name;
	}
};
</script>

<style lang="scss">
@import 'adsDashboard.scss';
</style>
